export class MoneyError extends Error {
    code;
    constructor(code) {
        super(code);
        this.code = code;
        this.name = 'MoneyError';
    }
}
/** Rejects rounding: a quote's financial amount must never change during conversion. */
export function decimalToUnits(value, decimals, maximum) {
    assertPrecision(decimals);
    if (value.length > 128 || !/^(0|[1-9]\d*)(\.\d+)?$/.test(value)) {
        throw new MoneyError('invalid_amount');
    }
    const [whole = '0', fraction = ''] = value.split('.');
    if (fraction.length > decimals && /[1-9]/.test(fraction.slice(decimals))) {
        throw new MoneyError('precision_loss');
    }
    const units = BigInt(whole + fraction.slice(0, decimals).padEnd(decimals, '0'));
    assertMaximum(units, maximum);
    return units;
}
export function unitsToDecimal(units, decimals) {
    assertPrecision(decimals);
    if (units < 0n)
        throw new MoneyError('invalid_amount');
    const digits = units.toString().padStart(decimals + 1, '0');
    if (decimals === 0)
        return digits;
    return `${digits.slice(0, -decimals)}.${digits.slice(-decimals)}`;
}
export function addUnits(values, maximum) {
    let total = 0n;
    for (const value of values) {
        if (value < 0n)
            throw new MoneyError('invalid_amount');
        total += value;
        assertMaximum(total, maximum);
    }
    assertMaximum(total, maximum);
    return total;
}
function assertPrecision(decimals) {
    // Bounds allocation for untrusted provider metadata, without assuming a token's precision.
    if (!Number.isInteger(decimals) || decimals < 0 || decimals > 36) {
        throw new MoneyError('invalid_precision');
    }
}
function assertMaximum(units, maximum) {
    if (maximum !== undefined && (maximum < 0n || units > maximum)) {
        throw new MoneyError('overflow');
    }
}
